import React, { Component, lazy, Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import { withRouter } from 'react-router';

import App from './app.container';
import { DEFAULT_LOCALE, translationMessages } from '../i18n';
import { NotFound } from './notFound';
import { ROUTES } from './routes';

// lazy loading MarketExperience is causing problems with booking flow
import { MarketExperience } from './marketExperience';

// lazy loading Filtered is causing problems with displaying results & results counter
import { Filtered } from './filtered';

// lazy loading Kiosk is causing problems with booking flow on Kiosk
import { Kiosk } from './kiosk';

// lazy loading Auth is causing problems with resetting password
import { Auth } from './auth';

/*eslint-disable import/dynamic-import-chunkname */
const Terms = lazy(() => import('./terms/terms.container.js'));
const Privacy = lazy(() => import('./privacy/privacy.container.js'));
const Cookies = lazy(() => import('./cookies/cookies.container.js'));
const Market = lazy(() => import('./market/market.container.js'));
const CancelConfirmation = lazy(() => import('./cancelConfirmation/cancelConfirmation.container.js'));
const GenericSuccess = lazy(() => import('./genericSuccess/genericSuccess.container.js'));
const GenericFailure = lazy(() => import('./genericFailure/genericFailure.container.js'));
const CancellationPolicy = lazy(() => import('./cancellationPolicy/policy.container.js'));
const Home = lazy(() => import('./home/home.container.js'));
const Account = lazy(() => import('./account/account.container.js'));
const AuthenticatedRoute = lazy(() =>
  import('../shared/components/authenticatedRoute/authenticatedRoute.container.js')
);

// eslint-disable-next-line react/display-name
const lazyLoad = Component => props => <Component {...props} />;

class RootContainer extends Component {
  render() {
    return (
      <IntlProvider locale={DEFAULT_LOCALE} messages={translationMessages[DEFAULT_LOCALE]}>
        <App>
          <Suspense fallback={<div />}>
            <Switch>
              <Route exact path={ROUTES.home} component={lazyLoad(Home)} />
              <Route path={ROUTES.kiosk()} component={Kiosk} />
              <Route path={ROUTES.market()} component={lazyLoad(Market)} />
              <Route path={ROUTES.marketExperience()} component={MarketExperience} />
              <Route path={ROUTES.auth.base} component={Auth} />
              <AuthenticatedRoute path={ROUTES.account.base} component={lazyLoad(Account)} />
              <Route exact path={ROUTES.cancel} component={lazyLoad(CancelConfirmation)} />
              <Route exact path={ROUTES.success} component={lazyLoad(GenericSuccess)} />
              <Route exact path={ROUTES.failure} component={lazyLoad(GenericFailure)} />
              <Route exact path={ROUTES.privacy} component={lazyLoad(Privacy)} />
              <Route exact path={ROUTES.standaloneCookies} component={lazyLoad(Cookies)} />
              <Route exact path={ROUTES.standaloneTerms} component={lazyLoad(Terms)} />
              <Route exact path={ROUTES.standalonePolicy()} component={lazyLoad(CancellationPolicy)} />
              <Route exact path={ROUTES.filtered} component={Filtered} />
              <Route component={NotFound} />
            </Switch>
          </Suspense>
        </App>
      </IntlProvider>
    );
  }
}

export default withRouter(RootContainer);
